"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onDateInputDay = onDateInputDay;
exports.onDateInputMinutes = onDateInputMinutes;
exports.onDateInputMonth = onDateInputMonth;
exports.onDateInputSecond = onDateInputSecond;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.string.pad-end");
require("core-js/modules/es6.regexp.to-string");
// 年月日
function onDateInputDay(event) {
  var newTime = event.target.value.toString();
  var time = newTime.padEnd(8, '0');
  if (time) {
    var formattedDate = time.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    return new Date(formattedDate);
  }
}
//年月日时分
function onDateInputMinutes(event) {
  var newTime = event.target.value.toString();
  var time = newTime.padEnd(12, '0');
  if (time) {
    var formattedDate = time.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5');
    return new Date(formattedDate);
  }
}
//年月日时分秒
function onDateInputSecond(event) {
  console.log('event.target.value', event.target.value);
  var newTime = event.target.value.toString();
  var time = newTime.padEnd(14, '0');
  if (time) {
    var formattedDate = time.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6');
    return new Date(formattedDate);
  }
}

// 年月
function onDateInputMonth(event) {
  var newTime = event.target.value.toString();
  var time = newTime.padEnd(6, '0');
  if (time) {
    var formattedDate = time.replace(/(\d{4})(\d{2})/, '$1-$2');
    return new Date(formattedDate);
  }
}